<template>
  <li class="status-tag-item">
    <div class="status-tag__indicator">
      <template v-if="icon">
        <IconSvg class="status-tag__icon" :icon="icon" has-fill />
      </template>
      <template v-else>
        <div v-html="html"></div>
      </template>
    </div>
    <div class="status-tag__content">
      <div class="status-tag__label">
        {{ label }}
        <span v-if="quantity !== null" class="status-tag__quantity">
          ({{ quantity }})
        </span>
      </div>
    </div>
  </li>
</template>

<script>
import IconSvg from '@/components/IconSvg/index.vue'

export default {
  components: {
    IconSvg
  },
  props: {
    icon: String,
    html: String,
    label: String,
    quantity: Number
  }
}
</script>

<style lang="scss" scoped>
.status-tag-item {
  list-style-type: none;
  display: flex;
  align-items: center;
  padding: 4px 0;
  min-height: 40px;

  .status-tag {
    &__indicator {
      width: 40px;
      text-align: center;
    }

    &__icon {
      font-size: 24px;
      // fill: rgb(var(--das-color-primary));
      fill: #2b8e59;
    }

    &__content {
      flex: 1;
      margin-left: 6px;
    }

    &__label {
    }

    &__quantity {
      white-space: nowrap;
    }
  }
}
</style>
